import { StandardEvents } from '@shopify/events';

class DefsetMnzProductBanner extends HTMLElement {
  #section;
  #request = 0;

  connectedCallback() {
    this.#section = this.closest('.shopify-section');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#update);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#update);
    this.#request++;
  }

  #update = async (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    const request = ++this.#request;
    try {
      const { detail } = await event.promise;
      if (!this.isConnected || request !== this.#request || !detail?.html) return;
      if (!detail.newProduct && detail.productId && String(detail.productId) !== this.dataset.productId) return;
      const updated = detail.html.querySelector('defset-mnz-product-banner');
      if (!updated) return;
      this.innerHTML = updated.innerHTML;
      this.hidden = updated.hidden;
      this.dataset.productId = updated.dataset.productId;
    } catch (error) {
      if (error?.name !== 'AbortError') console.warn('[Melnezera banner] Variant update unavailable.', error);
    }
  };
}

if (!customElements.get('defset-mnz-product-banner')) {
  customElements.define('defset-mnz-product-banner', DefsetMnzProductBanner);
}
